import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ExperimentService } from '@services/experiment/experiment.service';
import { REGIMEN_ROUTE_PATHS } from 'client/app/user/user-view/user-regimen/regimen.constants';

export const regimenNewRoutesGuard: CanActivateFn = () => {
  const experimentService = inject(ExperimentService);
  if (experimentService.regimenRouteExperiment) return true;
  return inject(Router).createUrlTree([REGIMEN_ROUTE_PATHS.ROOT]);
};
